import {
  VIN_TAB_ID,
  LICENSE_PLATE_TAB_ID,
  MMY_TAB_ID,
} from 'site-modules/shared/components/appraisal/appraisal-tabs-container/appraisal-tab-constants';

/**
 * Determines which tab should be active based on query parameters and settings.
 *
 * @param {Object} options - Configuration options
 * @param {boolean} options.hasVinQuery - Whether a VIN is present in the query string
 * @param {boolean} options.isLicensePlateTabDefault - Whether license plate tab should be default
 * @param {boolean} options.hasMMYQuery - Whether make/model/year are present in the query string
 * @param {boolean} options.isLookUpStyleView - Whether this is a style lookup view
 * @param {string} options.initialActiveTabId - The initially specified active tab ID
 * @returns {string} The ID of the tab that should be active
 */
export const getActiveTabId = ({
  hasVinQuery,
  isLicensePlateTabDefault,
  hasMMYQuery,
  isLookUpStyleView,
  initialActiveTabId,
}) => {
  if (isLookUpStyleView) return initialActiveTabId;
  if (hasVinQuery) return VIN_TAB_ID;

  return isLicensePlateTabDefault && !hasMMYQuery ? LICENSE_PLATE_TAB_ID : MMY_TAB_ID;
};
